import { createRequiredMessage } from '@domain/validations';
import * as Yup from 'yup';

/**
 * Function: getPresetCreationSchema
 *
 * This function returns a Yup schema for validating the creation of a preset.
 * The schema includes validation rules for name and description.
 *
 * @returns {Yup.ObjectSchema} The Yup schema for validating preset creation.
 */
export const getPresetCreationSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required("Name is required"),
  });
};
